<template>
  <div class="s-setting-container no-border">
    <div class="main-header">
      <div>Opportunity Notifications</div>
      <SaveCancelSection
        v-if="adminRole === 'admin'"
        :cancel="resetPartnerConfig"
        :save="updatePartnerConfig"
        :disabled="!changeCheck"
      />
    </div>
    <LeadSetting
      :criticalAlert="criticalAlert"
      :urgentAlert="urgentAlert"
      :watchingAlert="watchingAlert"
      :summary="summary"
      :watchingSummary="watchingSummary"
      :batchHour="batchHour"
      :emails="emails"
      :email="email"
      :onChange="handleChange"
      :addEmail="addLeadEmail"
      :removeEmail="removeLeadEmail"
      :errorObj="errorObj"
    />
    <ProcessOverlay
      :show="updating"
      text="Saving"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import LeadSetting from '@shared/components/partnerSettings/LeadSetting.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SaveCancelSection from '@shared/components/setting/shared/SaveCancelSection.vue';

import emailValidation from '@shared/lib/errorCatch/emailValidation';

export default {
  name: 'LeadSettingSection',
  components: {
    LeadSetting,
    ProcessOverlay,
    SaveCancelSection,
  },
  mixins: [partnerSettingsMixin],
  props: {
    partnerSettings: Object,
    update: Function,
  },
  data() {
    const {
      LEAD_CRITICAL = false,
      LEAD_URGENT = false,
      LEAD_WATCHING = false,
      LEAD_EMAIL = [],
      LEAD_SUMMARY = false,
      LEAD_SUMMARY_WATCHING = false,
      LEAD_BATCH_HOUR = '',
    } = this.partnerSettings;
    return {
      criticalAlert: LEAD_CRITICAL,
      urgentAlert: LEAD_URGENT,
      watchingAlert: LEAD_WATCHING,
      summary: LEAD_SUMMARY,
      watchingSummary: LEAD_SUMMARY_WATCHING,
      batchHour: LEAD_BATCH_HOUR,
      email: '',
      emails: LEAD_EMAIL,
      errorObj: {},
      updating: false,
    };
  },
  computed: {
    changeCheck() {
      const {
        LEAD_CRITICAL = false,
        LEAD_URGENT = false,
        LEAD_WATCHING = false,
        LEAD_EMAIL = [],
        LEAD_SUMMARY = false,
        LEAD_SUMMARY_WATCHING = false,
        LEAD_BATCH_HOUR = '',
      } = this.partnerSettings;
      let changes = false;
      if (LEAD_CRITICAL !== this.criticalAlert) {
        changes = true;
      }
      if (LEAD_URGENT !== this.urgentAlert) {
        changes = true;
      }
      if (LEAD_WATCHING !== this.watchingAlert) {
        changes = true;
      }
      if (LEAD_SUMMARY !== this.summary) {
        changes = true;
      }
      if (LEAD_SUMMARY_WATCHING !== this.watchingSummary) {
        changes = true;
      }
      if (LEAD_BATCH_HOUR !== this.batchHour) {
        changes = true;
      }
      if (!_.isEqual(LEAD_EMAIL, this.emails)) {
        changes = true;
      }
      if (!changes) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
      } else if (changes && !this.showWarningOnExit && !this.warningTab) {
        this.changePartnerSettingsValue('showWarningOnExit', true);
      }
      return changes;
    },
  },
  methods: {
    handleChange(field, value) {
      this[field] = value;
    },
    addLeadEmail() {
      if (emailValidation(this.email)
        && !this.emails.includes(this.email)) {
        const newEmails = this.emails.slice();
        newEmails.push(this.email);
        this.emails = newEmails;
        this.email = '';
      }
    },
    removeLeadEmail(email) {
      const newEmails = this.emails.slice();
      const idx = newEmails.indexOf(email);
      newEmails.splice(idx, 1);
      this.emails = newEmails;
    },
    resetPartnerConfig() {
      const {
        LEAD_CRITICAL = false,
        LEAD_URGENT = false,
        LEAD_WATCHING = false,
        LEAD_EMAIL = [],
        LEAD_SUMMARY = false,
        LEAD_SUMMARY_WATCHING = false,
        LEAD_BATCH_HOUR = '',
      } = this.partnerSettings;
      this.criticalAlert = LEAD_CRITICAL;
      this.urgentAlert = LEAD_URGENT;
      this.watchingAlert = LEAD_WATCHING;
      this.summary = LEAD_SUMMARY;
      this.watchingSummary = LEAD_SUMMARY_WATCHING;
      this.batchHour = LEAD_BATCH_HOUR;
      this.email = '';
      this.emails = LEAD_EMAIL;
      this.errorObj = {};
    },
    async updatePartnerConfig() {
      const {
        criticalAlert,
        urgentAlert,
        watchingAlert,
        summary,
        watchingSummary,
        batchHour,
        emails,
      } = this;
      this.changePartnerSettingsValue('showWarningOnExit', false);
      this.updating = true;
      await this.update({
        LEAD_CRITICAL: criticalAlert,
        LEAD_URGENT: urgentAlert,
        LEAD_WATCHING: watchingAlert,
        LEAD_EMAIL: emails,
        LEAD_SUMMARY: summary,
        LEAD_SUMMARY_WATCHING: watchingSummary,
        LEAD_BATCH_HOUR: batchHour,
      });
      this.updating = false;
    },
  },
};
</script>
